import HOCWatchValue from 'components/common/hoc-watch-value';
import TableEditableComponent from 'components/elements/table/table';
import { ColumnDataType } from 'components/elements/table/type';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

export default function CruiseSaleGuestTable(props: { parentIndex: number }) {
  const { t } = useTranslation();
  const name = `approvalable.cruiseSales.${props.parentIndex}.cruiseSaleGuests`;
  const value = HOCWatchValue({ keys: [name] });

  const columns = [
    {
      header: t('common:guest'),
      accessorKey: 'guestName',
      minSize: 250,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:guest_preferences'),
      accessorKey: 'guestPreferences',
      minSize: 100,
      dataType: ColumnDataType.tags,
      tagKeyName: 'label',
      maxTags: 2,
    },
    {
      header: t('guest:booking_preferences'),
      accessorKey: 'preferences',
      minSize: 250,
      dataType: ColumnDataType.tags,
      tagKeyName: 'label',
    },
  ];
  return (
    <div style={{ width: '100%' }}>
      <TableEditableComponent
        columns={columns}
        data={value[name]}
        dispatch={() => {}}
        disabled
        name={name}
      />
    </div>
  );
}
